<template>
  <div class="main" :style="{'background-image': 'url(' + public_path + '/static/images/share_bg.png)'}">
    <div class="content">
      <div class="title">您的分享码</div>
      <vue-qr :logoSrc="imageUrl" :logoMargin="5" :margin="0" :text="qrUrl" :logoScale="50" :size="534" class="qr" dotScale:></vue-qr>
      <div class="footer">
        <button class="btn">长按保存至相册</button>
        <div class="hint">-通过您的分享码下单的用户会及时通知您哦-</div>
      </div>
    </div>
  </div>
</template>
<script>
import { hostUrl } from '../../http/env.js'
import VueQr from 'vue-qr'
import _wx from '../../../static/js/chelun-wx-1.1.js'

export default {
  data () {
    return {
      public_path: process.env.PUBLICK_PATH,
      qrUrl: `${hostUrl}/agent/ecmall?channel_no=agent_share&agent_id=${JSON.parse(localStorage.userInfo).id}`,
      imageUrl: `${process.env.PUBLICK_PATH}/static/images/logo.png`,
      size: 80,
      backgroundAlpha: 1,
      iswx: _wx.isWx
    }
  },
  mounted () {
    // this.qrUrl = `${hostUrl}/agent/ecmall?channel_no=test_1&agent_id=${JSON.parse(localStorage.userInfo).id}`
    console.log(this.qrUrl)
    let shareParams = {
      timeline: '超级教练路考仪-快速领取',
      title: '超级教练路考仪-快速领取',
      desc: '智能学车辅助系统。设备可靠，系统操作简单，真实模拟考试。',
      imgUrl: 'http://picture.eclicks.cn/kaojiazhao/public/rem/share_img.jpg',
      link: `${hostUrl}/agent/ecmall?channel_no=agent_share&agent_id=${JSON.parse(localStorage.userInfo).id}`
    }
    this.$nextTick(() => {
      _wx.setMenuShare({
        timeline: shareParams.timeline,
        title: shareParams.title,
        desc: shareParams.desc,
        imgUrl: shareParams.imgUrl,
        link: shareParams.link,
        success () {
          console.log('分享成功')
        },
        fail (err) {
          console.log('分享失败')
          console.log(err)
        }
      })
    })
  },
  components: {
    VueQr
  }
}
</script>
<style lang="scss" scoped>
.main {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .content {
    text-align: center;
    // position: absolute;
    width: 6.1rem;
    height: 8.68rem;
    margin-left: .7rem;
    margin-top: 1.1rem;
    padding-top: .86rem;
    box-sizing: border-box;
    box-shadow: 0px 6px 30px 0px rgba(126, 138, 162, 0.3);
    background: #fff;
    .qr {
      display: inline-block;
      position: relative;
       z-index: 1;
    }
    .title {
      font-size: .4rem;
      margin-bottom: .56rem;
      font-weight: 400;
      color: #000;
    }
    .btn {
      width: 4.50rem;
      height: .90rem;
      background: linear-gradient(-81deg, rgba(134,210,143,1), rgba(94,204,173,1));
      border-radius: .45rem;
      font-size: .32rem;
      font-weight:400;
      color:rgba(255,255,255,1);
      text-shadow: 0px 2px 4px rgba(0, 72, 146, 0.35);
      margin-top: .45rem;
    }
    .hint {
      font-size: .26rem;
      font-weight:400;
      color:rgba(51,51,51,1);
      margin-top: .45rem;
      opacity:0.8;
    }
    .footer {
      position: relative;
      top: -2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/share/share.vue